import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faEye, faKipSign } from "@fortawesome/free-solid-svg-icons";


export default function TableActionButton({
  ariaLabel,
  className = "",
  disabled = false,
  icon,
  iconOnly = false,
  label = "Details",
  onClick,
  stopPropagation = true,
  type = "button",
}) 


{
  const[classButton, setClassButton]= useState("Details");

 useEffect(() => {

   if (label === "Details") {
     setClassButton("details_btn_transaction");

   }
   else  {
setClassButton("");
   }
 }, [])

  

  return (
    <button
      type={type}
      className={`new-table-action-button ${iconOnly ? "is-icon-only" : ""} ${className} ${classButton}`.trim()}
      disabled={disabled}
      aria-label={ariaLabel || label || "View"}
      onClick={(event) => {
        if (stopPropagation) {
          event.stopPropagation();
        }
        onClick?.(event);
      }}
    >
      {iconOnly ? null : <span>{label}</span>}

{
  label === "Details" ? (
    null
  ) : (
    <FontAwesomeIcon
      icon={
        icon ||
        (iconOnly
          ? faEye
          : faChevronRight)
      }
    />
  )
}
    </button>
  );
}
